import React, { useRef, useLayoutEffect, useState } from "react";
import styles from "@/components/styles";
import { IconClose } from "@/components/icon";

const { color } = styles;

const TabItem = ({
  name,
  icon,
  active,
  minWidth,
  maxWidth,
  onClick,
  onContextMenu,
  onItemClose,
  withoutClose,
  clstag,
  itemsLength
}: {
  name: string;
  icon: any;
  active?: boolean;
  minWidth?: number;
  maxWidth?: number;
  onClick: () => void;
  onItemClose?: () => void;
  onContextMenu?: () => void;
  withoutClose?: boolean;
  clstag?: string;
  itemsLength?: number;
}) => {
  const ref = useRef(null);
  const [offsetWidth, setOffsetWidth] = useState(0);
  useLayoutEffect(() => {
    // @ts-ignore
    setOffsetWidth(ref?.current?.offsetWidth);
  }, [itemsLength, maxWidth]);
  return (
    <div
      style={{
        position: "relative",
        cursor: "pointer",
        overflow: "hidden",
        height: "40px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flex: 1,
        // 可以改成width
        maxWidth: maxWidth || "180px",
        minWidth: minWidth,
        padding: "0 12px",
        borderRadius: "12px 12px 0 0"
      }}
      className={`${active ? "active-tab" : "tab"}`}
      onClick={onClick}
      onContextMenu={onContextMenu}
      tabIndex={0}
      ref={ref}
    >
      <span
        style={{
          display: offsetWidth <= 55 && active ? "none" : "inline-flex",
          color: color.primary2,
          width: 16
        }}
      >
        {icon}
      </span>
      <span
        style={{
          display: offsetWidth <= 68 ? "none" : "inline-block",
          fontSize: "13px",
          margin: "0 8px",
          height: "20px",
          overflow: "hidden",
          width: "134px",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap"
        }}
      >
        {name}
      </span>
      {!withoutClose && (
        <span
          style={{
            color: "#62656D",
            fontSize: "9px",
            marginTop: "2px",
            display: offsetWidth < 55 && !active ? "none" : ""
          }}
          clstag={clstag}
          onClick={onItemClose}
        >
          {IconClose}
        </span>
      )}
    </div>
  );
};

export default TabItem;
